/**
 * TokenData contains token contract addresses of selected tokens
 */
const TokenData = [
  {
    'symbol': 'AVAX',
    'address': '',
    'chainId': '0xa869'
  },
  {
    'symbol': 'LINK',
    'address': '0x2F0708E5FB96fd1E9F21eAbAd06EE5F337586A02',
    'chainId': '0xa869'
  },
  {
    'symbol': 'WETH',
    'address': '0xFE314b188135893A684EE997eDcb81823Ffb575B',
    'chainId': '0xa869'
  },
  {
    'symbol': 'USDT',
    'address': '0xaeC89D2e476a57498b2FB661d3B6667C96BbC11a',
    'chainId': '0xa869'
  },
  {
    'symbol': 'CONTRACT-LINK',
    'address': '0x2F0708E5FB96fd1E9F21eAbAd06EE5F337586A02',
    'chainId': '0xa869'
  },
  {
    'symbol': 'CONTRACT-WETH',
    'address': '0xFE314b188135893A684EE997eDcb81823Ffb575B',
    'chainId': '0xa869'
  },
  {
    'symbol': 'CONTRACT-USDT',
    'address': '0xaeC89D2e476a57498b2FB661d3B6667C96BbC11a',
    'chainId': '0xa869'
  }
];

export default TokenData;